import { screenshots } from "@/data/images";

export interface Product {
    id: string;
    name: string;
    title: string;
    description: string;
    presentation: string | null;
    image: string;
    category: string;
    features: string[];
    benefits: string[];
    screenshots: string[];
    useCases: {
        title: string;
        description: string;
    }[];
}

export const products: Product[] = [
    {
        "id": "sa-inventory",
        "name": "SA Inventory",
        "title": "Мобильное приложение для управления товарно-материальными ценностями",
        "description": "SA Inventory — это мощное мобильное приложение для управления товарно-материальными ценностями и документооборотом в ритейле. Оно обеспечивает эффективное выполнение операций приёмки, инвентаризации, переоценки, внутреннего перемещения и печати ценников, включая офлайн-режим и полную интеграцию с 1С.",
        "presentation": "https://drive.google.com/file/d/1Vh8p4jNHHZgCSvCmjl2SgeNKZjsVog8j/view",
        "image": "https://images.unsplash.com/photo-1614332287897-cdc485fa562d?q=80&w=2070",
        "category": "inventory",
        "features": [
            "Авторизация по данным из 1С с поддержкой выбора страны",
            "Режимы работы: онлайн (синхронизация с сервером) и офлайн (инвентаризация)",
            "Интерактивные задания: приёмка, инвентаризация, переоценка, трансферы, внутренние перемещения",
            "Сканирование товаров, полок и коробок с помощью встроенного сканера или камеры",
            "Интуитивная навигация по уровням: задания, помещения, полки, товары",
            "Автоматическая и ручная выгрузка данных в 1С",
            "Отображение статусов синхронизации и работы устройства",
            "Создание и редактирование полок и коробок в процессе сканирования",
            "Работа с браком, подарочными сертификатами, переоценкой и moneymapping",
            "Печать ценников через Bluetooth-принтеры Zebra и TSC",
            "Поиск и добавление товаров вручную или из базы"
        ],
        "benefits": [
            "Сокращение времени на приёмку поставок и инвентаризацию до 50%",
            "Минимизация ошибок за счёт онлайн-контроля сканирования и подсказок",
            "Поддержка работы в офлайн-режиме при нестабильном интернете",
            "Унификация процессов на всех уровнях: от магазина до распределительного центра",
            "Снижение издержек за счёт автоматизации документооборота и интеграции с 1С",
            "Улучшение качества данных и прозрачности складских операций"
        ],
        "useCases": [
            {
                "title": "Магазины розничной сети",
                "description": "Оперативная приёмка товаров, проведение переоценок, печать ценников и выполнение инвентаризаций в торговых залах."
            },
            {
                "title": "Складские комплексы",
                "description": "Инвентаризация, сборка трансферов, контроль остатков, управление внутренними перемещениями между помещениями."
            },
            {
                "title": "Ритейлеры с распределённой сетью",
                "description": "Централизованное управление заданиями из 1С с возможностью работы в разных странах и на нескольких устройствах одновременно."
            }
        ],
        "screenshots": [
            screenshots.saInventory1,   
            screenshots.saInventory2,
            screenshots.saInventory3
        ]
    }
    ,
    {
        "id": "sa-retail",
        "name": "SA Retail",
        "title": "Мобильное приложение для управления розничной торговлей",
        "description": "SA Retail — это современное мобильное приложение для автоматизации операций в торговом зале. Оно помогает продавцам эффективно обслуживать клиентов, управлять заказами, примерочными, перемещением и резервированием товаров. Интеграция с 1С обеспечивает синхронизацию всех действий в реальном времени.",
        "presentation": "https://drive.google.com/file/d/1Vh8p4jNHHZgCSvCmjl2SgeNKZjsVog8j/view",
        "image": "https://images.unsplash.com/photo-1581093448799-41a9c1f3c0f5?q=80&w=2070",
        "category": "retail",
        "features": [
          "Активация клиента и создание персонального 'Избранного'",
          "Добавление товаров в избранное и управление ими",
          "Создание заданий на примерку и перемещение моделей в примерочные",
          "Сбор заданий по помещениям с помощью сканера или камеры",
          "Отображение статуса выполнения заданий и визуальная подсветка собранных товаров",
          "Работа с примерочной: выкуп, завершение обслуживания, возврат товаров",
          "Резервирование товаров как из избранного, так и из примерочной",
          "Создание упрощенных заданий на перемещение с ускоренным сбором",
          "Система пуш-уведомлений о новых заданиях и статусах",
          "Интеграция с 1С и обмен данными в реальном времени"
        ],
        "benefits": [
          "Ускорение обслуживания клиентов в торговом зале",
          "Создание индивидуального подхода через функционал избранного и примерочной",
          "Удобная работа с товарами без обращения к кассе",
          "Снижение нагрузки на сотрудников и повышение качества сервиса",
          "Повышение точности учета при помощи системы заданий и сканирования",
          "Интуитивный интерфейс, доступный для обучения за 15 минут"
        ],
        "useCases": [
          {
            "title": "Индивидуальное обслуживание клиента",
            "description": "С помощью активации клиента, избранного и примерочной продавец сопровождает клиента от выбора товара до покупки, не покидая торговый зал."
          },
          {
            "title": "Быстрое формирование примерки",
            "description": "Создание задания на примерку, сбор товаров по помещениям и их перемещение в примерочную — всё из приложения."
          },
          {
            "title": "Оптимизация логистики товаров внутри магазина",
            "description": "Упрощенные задания на перемещение позволяют быстро перемещать товар между помещениями и отслеживать выполнение."
          },
          {
            "title": "Резервирование товара для клиента",
            "description": "Продавец может зарезервировать товар прямо из примерочной или избранного клиента с указанием контактов и помещения."
          },
          {
            "title": "Пуш-уведомления по заданиям",
            "description": "Сотрудник всегда в курсе новых заданий и напоминаний, даже если приложение закрыто."
          }
        ],
        "screenshots": [
          "https://images.unsplash.com/photo-1515165562835-cfba588b73dc?q=80&w=2070",
          "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?q=80&w=2070",
          "https://images.unsplash.com/photo-1515169284823-b8f8f71a42b7?q=80&w=2070"
        ]
      },
      {
        "id": "POSS",
        "name": "POSS",
        "title": "Software solution for fashion retail management",
        "description": "Point of Sale System is a tech solution including a software for your POS terminal with easy going and friendly interface that allows you to manage a full retail process, software for admin area with the focus on flexibility of settings for POS terminal management and reports, and integration to popular databases and third-party services. Additionally you have an option to use the admin area as a database of your products as a good start for your business.",
        "presentation": null,
        "image": "https://images.unsplash.com/photo-1581093448799-41a9c1f3c0f5?q=80&w=2070",
        "category": "retail",
        "features": [
          "Full retail process management (search/sell/return items, paper/electronic checks or use electronic ones, manage all checks’ info and listing)",
          "Marking code items’ retail",
          "Hints while payment process",
          "Anti-fraud settings (which you allows to set to particular features)",
          "Easy going modern speed interface",
          "Admin area with flexible settings (items, users, sales, reports, etc.) based on your business needs",
          "1C databases (or others) and third-party services integration",
          "Online and offline work support."
        ],
        "benefits": [
          "May increase the progress and engagement of your employees’ to the working process",
          "May allow you to apply and use system settings based on your business size",
          "Could support online and offline POS terminal work",
          "Could provide you an option to build your own reports or monitor any actions using system logs",
          "Could allow you to use popular databases or skip DB integration and use our admin area as a DB for your items",
        ],
        "useCases": [
          {
            "title": "In top notch UI we trust ",
            "description": "Easy going interface designed for speed and increasing your employees’ interest and engagement into the working process"
          },
          {
            "title": "We are care of your flexibility",
            "description": "Admin area built with the focus on flexibility of your retail process management and reports"
          },
          {
            "title": "Seamless integration is our second name",
            "description": "Connect popular databases and third-party services. Or you can use our admin area as a DB as a good start in your business"
          }
        ],
        "screenshots": [
          "https://images.unsplash.com/photo-1515165562835-cfba588b73dc?q=80&w=2070",
          "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?q=80&w=2070",
          "https://images.unsplash.com/photo-1515169284823-b8f8f71a42b7?q=80&w=2070"
        ]
      }
      
      
];
